import { Col, Form, Input, PageHeader, Row } from "antd";
import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Team } from "shared/interfaces/Team";
import "./TeamManagement.scss";

interface TeamDetailsProps {
  team?: Team;
}
const TeamSubscription: React.FC<TeamDetailsProps> = (props) => {
  const { team } = props;
  const { t } = useTranslation("radar");
  const [form] = Form.useForm();
  if (team) team.subscriptionStartDate = new Date().toLocaleDateString();
  if (team) team.subscriptionNextChargeDate = new Date().toLocaleDateString();

  const statuses = [
    t("pages.TeamManagement.pending"),
    "",
    t("pages.TeamManagement.active"),
    t("pages.TeamManagement.inactive"),
  ];

  const status = statuses[team?.teamStatus || 0];

  const usersTeam =
    (team?.licenseAmount !== null &&
      t("pages.TeamManagement.usersTeam", { amount: team?.licenseAmount })) ||
    "";

  useEffect(() => {
    form.resetFields();
  }, [team, form]);

  return (
    <>
      <Row>
        <Col xs={24}>
          <PageHeader title={t("pages.TeamManagement.subscription")} />
          <Row justify="center">
            <Col xs={18}>
              <Form
                layout="horizontal"
                form={form}
                initialValues={team}
                style={{ color: "#fff" }}
              >
                <Row gutter={32}>
                  <Col xs={6}>
                    <span className="label">
                      {t("pages.TeamManagement.status")}
                    </span>
                  </Col>
                  <Col xs={12}>
                    <Form.Item>
                      <Input disabled value={status} />
                    </Form.Item>
                  </Col>
                  <Col xs={6}></Col>
                </Row>
                <Row gutter={32}>
                  <Col xs={6}>
                    <span className="label">
                      {t("pages.TeamManagement.usersTeamLabel")}
                    </span>
                  </Col>
                  <Col xs={12}>
                    <Form.Item>
                      <Input disabled value={usersTeam} />
                    </Form.Item>
                  </Col>
                  <Col xs={6}></Col>
                </Row>
                <Row gutter={32}>
                  <Col xs={6}>
                    <span className="label">
                      {t("pages.TeamManagement.dueDate")}
                    </span>
                  </Col>
                  <Col xs={12}>
                    <Form.Item name="dueDate">
                      <Input disabled />
                    </Form.Item>
                  </Col>
                  <Col xs={6}></Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </Col>
      </Row>
    </>
  );
};
export default TeamSubscription;
